export const TEST_ID = 'statusBadge';
